import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVentBent = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 10,
	height: 20,
	viewBox: "0 0 10.0 20.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 20.0 L 0.0 5.0 A 5.0 5.0 0.0 1 1 10.0 5.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgVentBent;
